<template>
  <b-container>
    <b-row>
      <b-col sm="auto" md="10" lg="8" xl="6">
        <h1>Medlemmar</h1>
        <MembersStats :members="members" />
        <MembersList :members="members" :memberships="membershipFees" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { db } from '@/firebaseConfig.js'
  import { collection, onSnapshot, query, where } from 'firebase/firestore'
  import MembersList from '@/components/MembersList.vue'
  import MembersStats from '@/components/MembersStats.vue'

  export default {
    mounted() {
      const q = query(collection(db, 'members'))
      this.unsubscribe = onSnapshot(q, (querySnapshot) => {
        const membs = []
        querySnapshot.forEach((doc) => {
          membs.push({ id: doc.id, ...doc.data() })
        })
        this.members = membs
      })

      const q1 = query(collection(db, 'fees'), where('type', '==', 'membership'))
      this.unsubscribe = onSnapshot(q1, (querySnapshot) => {
        const fees = []
        querySnapshot.forEach((doc) => {
          fees.push({ id: doc.id, ...doc.data() })
        })
        this.membershipFees = fees
      })
    },
    destroyed() {
      this.unsubscribe()
    },
    data() {
      return {
        members: [],
        membershipFees: [],
        unsubscribe: null
      }
    },
    components: { MembersList, MembersStats }
  }

</script>
